import styled from 'vue-styled-components';

import theme from '@/config/theme';

const Link = styled.a`
  color: ${theme.colors.gray6};
  display: block;
  font-size: ${theme.font.sizes.p2};
  margin-top: ${theme.spacings.xxxlarge};
  text-align: center;

  &:hover {
    color: ${theme.colors.primaryLight};
  }
`;

export default Link;
